var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32397 3.99685C5.40598 3.00984 7.04263 2.62573 8.58184 3.44775L17.9057 8.42723C20.7001 9.91957 20.6974 14.1105 17.9005 15.5985L8.58151 20.5565C7.04138 21.3758 5.40561 20.9893 4.3251 20.0011C3.25116 19.0188 2.68898 17.4205 3.18873 15.7587L4.31428 12.0161L3.18254 8.23852C2.68441 6.57584 3.24856 4.97784 4.32397 3.99685ZM6.10186 13.0166L5.104 16.3347C4.83776 17.22 5.13586 18.0322 5.67492 18.5253C6.2074 19.0123 6.93736 19.1658 7.64214 18.7908L16.9611 13.8329C18.3447 13.0967 18.3466 10.93 16.9636 10.1914L7.63967 5.21193C6.93517 4.83569 6.20491 4.98817 5.67183 5.47444C5.13216 5.96674 4.83302 6.77871 5.09841 7.66453L6.10268 11.0166H8.32936C8.88165 11.0166 9.32936 11.4643 9.32936 12.0166C9.32936 12.5689 8.88165 13.0166 8.32936 13.0166H6.10186Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDefault);
export default __webpack_public_path__ + "static/media/send-default.5d7ea153fe7381d19df5b6d0fc3078c1.svg";
export { ForwardRef as ReactComponent };